import Service from '@/helpers/service'

export default {

  get(page, params) {
    return Service().get('vendor?page=' + page,  {params});
  },
  show(id) {
    return Service().get('vendor/'+id);
  },
  create(params) {
    return Service().post('vendor', params);
  },
  update(id, params) {
    return Service().patch('vendor/'+id, params);
  },
  delete(id) {
    return Service().delete('vendor/'+id);
  },
  search(params) {
    return Service().post('vendor/search', params);
  }
}
